import { useFormik } from 'formik';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import TableLoading from '../../../../core/common/loadingComponent/TableLoading';
import NoRecordFound from '../../../../core/common/noRecord/NoRecordFound';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import TableHeading from '../../../../core/common/tableHeading/TableHeading';
import { useTableSelection } from '../../../../core/hooks/useTableSelection';
import { useGetjobScopeDetailsByIdQuery, useGetjobScopeHistoryQuery, useUpsertJobScopeMutation } from '../../../../services/EndPointsApis';
import { initialValuesJobScope } from '../../Projects/Accept Sale Wizard/InitialValuesJobScope';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../../Config/Constants';
import DateComp from '../../../../core/common/dateComponent/DateComp';

const JobScope = ({ projectId, showHistory, showRibbonJobScope, storeProjectId }: any) => {

    //PermissionHook
    const { view: viewJobScope, edit: editJobScope, create: createJobScope } = usePermission(constantsPermission?.moduleId?.jobScope);

    const params = useParams()
    const [searchStr, setSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("createDT");
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortedColumn, setSortedColumn] = useState("createDT");
    const [isRowClicked, setIsRowClicked] = useState(false)
    const [immediateSearchStr, setImmediateSearchStr] = useState('');

    //Upsert Api
    const [UpsertJobScope, { data, isError, error, isSuccess, isLoading }] = useUpsertJobScopeMutation();

    //Get Api
    const { data: jobScopeData, refetch, isLoading: isLoadingScope } = useGetjobScopeDetailsByIdQuery({ Id: projectId || storeProjectId });

    //Get history Api
    const { data: jobScopeHistory, refetch: refetchHistory, isLoading: isLoadingHistory } = useGetjobScopeHistoryQuery({ projectId: projectId, searchStr: searchStr || '', });

    //Custom Table Hook 
    const {
        isTableHeadChecked,
        selectedIndividualCheckboxId,
        selectedItemData: UserData,
        handleTableHeadChange,
        handleCheckItem,
        handleRowClick,
        handleRowDoubleClick,
        handleDelete
    } = useTableSelection(jobScopeHistory?.result || [], 'userAccountId');

    //formik   

    const formik = useFormik({
        initialValues: initialValuesJobScope,
        onSubmit: (values) => {
            UpsertJobScope({ ...values })
        },

    });

    useEffect(() => {

        if (isSuccess) {
            toast.success(data?.message);
            refetch()
            refetchHistory()
        }
    }, [isSuccess]);

    useEffect(() => {
        if (jobScopeData?.result && Object.keys(jobScopeData?.result).length > 0) {
            formik.setValues({ ...jobScopeData?.result });
            // setDisabledata(true)
        } else {
            // setUpdateId(0);
        }
    }, [jobScopeData]);

    // useEffect(() => {
    //     if (setJobScopeData) {
    //         setJobScopeInitialValues(initialValuesJobScope)
    //         setJobScopeData(formik)
    //     }
    // }, [setJobScopeData, formik.values])

    // useEffect(() => {
    //     if (jobScopeDetailsData) {
    //        formik.setValues({...jobScopeDetailsData})
    //     }
    // }, [jobScopeDetailsData])


    const handleSort = (property: string) => {
        setSortBy(property);
        if (sortedColumn === property) {
            setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortedColumn(property);
            setSortOrder("asc");
        }
        // Perform additional sorting logic...
    };

    const handleRowClicked = (data: any) => {
        handleRowClick(data);
        setIsRowClicked(true);
    }
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value);
        delayedSearch(value);
    };
    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );

    useEffect(() => {
        if (searchStr === "" ||
            sortOrder === "" ||
            sortBy === "") {
            refetchHistory()
        }
    }, [searchStr, sortOrder, sortBy]);

    useEffect(() => {
        refetch()
        refetchHistory()
    }, [])


    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    {editJobScope &&
                        <Ribbon
                            // items={items}
                            buttonText={isLoading ? "Loading..." : "Save"}
                            onClickbtn={formik.handleSubmit}
                            buttonClass="add-popup ribbon-btn"
                        />
                    }
                </div>
            </div>
            <div className='row' style={{ overflow: 'auto' }}>
                <div className='col-md-12'>
                    <div className='row mt-3'>
                        <div className={`col-md-${showRibbonJobScope ? 12 : 5}`}>
                            <div className='card'>
                                <div className='card-body card-css'>
                                    <h5 className='mb-3'>Job Scope:</h5>
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className='d-flex justify-content-between '>
                                            {/* First div */}
                                            <div className="first-div" style={{ width: '330px' }}>
                                                {formik.values.jobScopeResults?.filter((_, index) => index % 2 === 0).map((item, index) => {
                                                    const originalIndex = formik.values.jobScopeResults.findIndex(i => i.surveyMasterId === item.surveyMasterId);

                                                    return (
                                                        <div key={index} className='d-flex justify-content-between align-items-center'>
                                                            <label className='mb-2'>{item.name}</label>
                                                            {item.name.includes('#') ? (
                                                                <input
                                                                    type='number'
                                                                    defaultValue={item.surveyResultOriginal}
                                                                    style={{ width: '50px' }}
                                                                    {...formik.getFieldProps(`jobScopeResults[${originalIndex}].surveyResultOriginal`)}
                                                                    onChange={(e) => formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                    onKeyDown={(e) => {
                                                                        if (['.', ',', 'e', 'E'].includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                            ) : (
                                                                <label className="checkboxs mb-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item.surveyResultOriginal === '1'}
                                                                        onChange={() => {
                                                                            const newValue = item.surveyResultOriginal === '1' ? '0' : '1';
                                                                            formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, newValue); // Ensure correct index
                                                                        }}
                                                                    />
                                                                    <span className="checkmarks" />
                                                                </label>
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                            </div>
                                            {/* Second div */}
                                            <div className="second-div" style={{ width: '330px' }}>
                                                {formik.values.jobScopeResults?.filter((_, index) => index % 2 !== 0).map((item, index) => {
                                                    const originalIndex = formik.values.jobScopeResults.findIndex(i => i.surveyMasterId === item.surveyMasterId);

                                                    return (
                                                        <div key={index} className='d-flex justify-content-between align-items-center '>
                                                            <label className='mb-2'>{item.name}</label>
                                                            {item.name.includes('#') ? (
                                                                <input
                                                                    type='number'
                                                                    defaultValue={item.surveyResultOriginal}
                                                                    style={{ width: '50px' }}
                                                                    // onChange={(e) => handleInputChange(item.surveyMasterId, e.target.value)}
                                                                    {...formik.getFieldProps(`jobScopeResults[${originalIndex}].surveyResultOriginal`)}
                                                                    onChange={(e) => formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                    onKeyDown={(e) => {
                                                                        if (['.', ',', 'e', 'E'].includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                            ) : item.fieldType === "Text" ? (
                                                                <div className='d-flex gap-2 align-items-center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: "100px" }}
                                                                        {...formik.getFieldProps(`jobScopeResults[${originalIndex}].surveyResultOriginal`)}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <label className="checkboxs mb-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item.surveyResultOriginal === '1'}
                                                                        onChange={() => {
                                                                            const newValue = item.surveyResultOriginal === '1' ? '0' : '1';
                                                                            formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, newValue); // Ensure correct index
                                                                        }}
                                                                    />
                                                                    <span className="checkmarks" />
                                                                </label>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                        {/* <div className='col-md-2'></div> */}
                        {!showHistory &&
                            <div className='col-md-7'>
                                <div className='card bg-lightGray'>
                                    <div className='card-body card-css'>
                                        <h5 className='mb-3'>History:</h5>
                                        <>
                                            <div className=" icon-form mt-2 mb-3">
                                                <span className="form-icon">
                                                    <i className="ti ti-search" />
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search"
                                                    value={immediateSearchStr}
                                                    onChange={handleSearchChange}
                                                />
                                            </div>
                                        </>
                                        {/* <div className='d-flex justify-content-between'>
                                        <div className="first-div" style={{width:'330px'}}>
                                            {jobScopeData?.result?.jobScopeResults?.filter((_:any, index:any) => index % 2 === 0).map((item:any, index:any) => {
                                                const originalIndex = formik.values.jobScopeResults.findIndex(i => i.surveyMasterId === item.surveyMasterId);

                                                return (
                                                    <div key={index} className='d-flex justify-content-between mb-2'>
                                                        <label className='mb-0'>{item.name}:</label>
                                                        {item.name.includes('#') ? (
                                                            <input
                                                                type='number'
                                                                // defaultValue={item.surveyResultOriginal}
                                                                style={{ width: '50px' }}
                                                                value={item.surveyResultOriginal}
                                                                // onChange={(e) => formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                readOnly
                                                            />
                                                        ) : (
                                                            <label className="checkboxs mt-1">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={item.surveyResultOriginal === '1'}
                                                                    // onChange={() => {
                                                                    //     const newValue = item.surveyResultOriginal === '1' ? '0' : '1';
                                                                    //     formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, newValue);

                                                                    // }}
                                                                    disabled
                                                                />
                                                                <span className="checkmarks" />
                                                            </label>
                                                        )}
                                                    </div>
                                                );
                                            })}

                                        </div>
                                        <div className="second-div" style={{width:'330px'}}>
                                            {jobScopeData?.result?.jobScopeResults?.filter((_:any, index:any) => index % 2 !== 0).map((item:any, index:any) => {
                                                const originalIndex = formik.values.jobScopeResults.findIndex(i => i.surveyMasterId === item.surveyMasterId);

                                                return (
                                                    <div key={index} className='d-flex justify-content-between mb-2'>
                                                        <label className='mb-0'>{item.name}:</label>
                                                        {item.name.includes('#') ? (
                                                            <input
                                                                type='number'
                                                                value={item.surveyResultOriginal}
                                                                style={{ width: '50px' }}
                                                                // onChange={(e) => handleInputChange(item.surveyMasterId, e.target.value)}
                                                                // {...formik.getFieldProps(`jobScopeResults[${originalIndex}].surveyResultOriginal`)}
                                                                // onChange={(e) => formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                readOnly
                                                            />
                                                        ) : (
                                                            <label className="checkboxs mt-1">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={item.surveyResultOriginal === '1'}
                                                                    // onChange={() => {
                                                                    //     const newValue = item.surveyResultOriginal === '1' ? '0' : '1';
                                                                    //     formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, newValue); // Ensure correct index
                                                                    // }}
                                                                    disabled
                                                                />
                                                                <span className="checkmarks" />
                                                            </label>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div> */}
                                        <div className="table-responsive">
                                            <table className="table datanew dataTable no-footer table-hover">
                                                <thead>
                                                    <tr>
                                                        {/* <th>
                                                        <input
                                                            type="checkbox"
                                                            className='form-check-input cursor-pointer'
                                                            checked={isTableHeadChecked}
                                                            onChange={handleTableHeadChange}
                                                        />
                                                    </th> */}
                                                        <TableHeading
                                                            label='Field Name'
                                                            // sortedColumn='userID'
                                                            columnId='fieldName'
                                                            // sortOrder='desc'
                                                            key='userId'
                                                            handleSort={handleSort}
                                                        />
                                                        <TableHeading
                                                            label='Previous Value'
                                                            // sortedColumn='firstName'
                                                            columnId='previousValue'
                                                            // sortOrder='desc'
                                                            handleSort={handleSort}
                                                        />
                                                        <TableHeading
                                                            label='Current Value'
                                                            // sortedColumn='email'
                                                            columnId='currentValue'
                                                            // sortOrder='desc'
                                                            handleSort={handleSort}
                                                        />
                                                        <TableHeading
                                                            label='Date Time'
                                                            // sortedColumn='cellPhone'
                                                            columnId='dateTime'
                                                            // sortOrder='desc'
                                                            handleSort={handleSort}
                                                        />
                                                        <TableHeading
                                                            label='Updated By'
                                                            // sortedColumn='cellPhone'
                                                            columnId='updatedBy'
                                                            // sortOrder='desc'
                                                            handleSort={handleSort}
                                                        />
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!isLoadingHistory && <>
                                                        {jobScopeHistory?.result?.length > 0 ? (
                                                            <>
                                                                {jobScopeHistory?.result?.map((data: any, index: any) => (
                                                                    <tr key={data?.index} onClick={() => handleRowClicked(data)}
                                                                        className={selectedIndividualCheckboxId.includes(data?.index) ? 'selected-row' : ''}>
                                                                        {/* <td>
                                                                        <TextField
                                                                            type="checkbox"
                                                                            fieldClass='form-check-input cursor-pointer'
                                                                            checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.userAccountId)}
                                                                            onChange={(e) => handleCheckItem(e, data)}
                                                                        />
                                                                    </td> */}
                                                                        <td>{data?.fieldName}</td>
                                                                        <td>{data?.previousValue}</td>
                                                                        <td>{data?.currentValue}</td>
                                                                        <td><DateComp formattedDate={data?.dateTime} /></td>
                                                                        <td>{data?.updateBy}</td>

                                                                    </tr>
                                                                ))}
                                                            </>
                                                        ) :
                                                            (
                                                                <tr>
                                                                    <td colSpan={7}>
                                                                        <NoRecordFound />
                                                                    </td>
                                                                </tr>
                                                            )}
                                                    </>}
                                                    {isLoadingHistory &&
                                                        <TableLoading />
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                </div>
                <div className='col-md-12 d-flex justify-content-end '>
                    <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px", zIndex: "1" }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
                </div>
            </div>
        </>
    )
}

export default JobScope